import { createGlobalStyle } from 'styled-components';

export const Styles = createGlobalStyle`
  .invalid {
    color: #ff4444;
    font-weight: 500;
    align-items: center
  }
  .valid {
    color: #5eb668;
    font-weight: 500;
    align-items: center
  }

`;
